import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import ReactTooltip from "react-tooltip";
import logo from "../logo.png";
import "../App.css";
import { Link, NavLink, withRouter } from "react-router-dom";
import SlideDrawer from "./slideDrawer/SlideDrawer5";
import Backdrop from "./backDrop/Backdrop";
import CloseX from "./CloseX/CloseX";
import {
  BsArrowLeftShort,
  BsPerson,
  BsList,
  BsAppIndicator,
  BsLock,
  BsPen,
  BsHouse,
} from "react-icons/bs";
import { FaHandshake } from "react-icons/fa";
import { IoIosLogOut } from "react-icons/io";
import { CheckUserLogin } from "../sessions/CheckUserLoggin";
import { BiLogOutCircle } from "react-icons/bi";

class Header extends React.Component {
  state = {
    searchValue: "",
    response: [],
    queryResults: [],
    resultsComponent: false,
    open: true,
    openLogo: false,
    arrowIcon: true,
    email: "",
    phone: "",
    customername: "",
    sideDrawerOpen: false,
    showHeader: "",
    campaignCount: 0,
  };

  drawerToggleClickHandler = () => {
    this.setState((prevState) => {
      return { sideDrawerOpen: !prevState.sideDrawerOpen };
    });
  };

  backDropClickHandler = () => {
    this.setState({ sideDrawerOpen: false });
  };

  componentDidMount() {
    const partnerid = localStorage.getItem("partnerid");
  }

  handleSearchArrow = () => {
    this.setState({ open: true });
    this.setState({ openLogo: false });
    this.setState({ arrowIcon: true });
  };

  Appheader = () => {
    this.setState({ open: true });
    this.setState({ openLogo: false });
    this.setState({ arrowIcon: true });
  };

  handleLogout = async () => {
    try {
      await fetch("https://karamale.com/apps/kscanner/logout.php", {
        method: "GET",
        credentials: "include", // sends cookies like sessionId
      });

      // Clear local data and redirect
      localStorage.clear();
      window.location.href = "/login";
      console.log("Loggedout");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  render() {
    let slideDrawer;
    let backDrop;
    let closeX;

    if (this.state.sideDrawerOpen) {
      slideDrawer = <SlideDrawer />;
      backDrop = <Backdrop click={this.backDropClickHandler} />;
      closeX = <CloseX click={this.backDropClickHandler} />;
    }

    const { queryResults } = this.state;
    const style = this.state.open ? { display: "none" } : {};
    const logoStyle = this.state.openLogo ? { display: "none" } : {};
    const arrowIconStyle = this.state.arrowIcon ? { display: "none" } : {};
    const date = new Date();
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    const fulldate = year + "-" + month + "-" + day;
    let event = "";

    return (
      <div className="App">
        <CheckUserLogin />
        {slideDrawer}
        {backDrop}
        {closeX}
        <header className="App-header" onClick={this.Appheader}>
          <div className="row align-items-center justify-content-center pl-3">
            <div className="Header-wrapper col-lg-4 col-md-10 col-sm-10 col-10 p-3 mt-0">
              <Link to="/in" className="links logo-karamale" style={logoStyle}>
                <img
                  src={"https://karamale.com/karamale.png"}
                  alt={logo}
                  width={150}
                  align=""
                />
                {/* <br />
                <label className="text-red text-13 text-center mt-0">
                  Affiliate
                </label> */}
              </Link>
            </div>

            <div
              className="col-lg-2 col-md-1 col-2 more-col-mobile mobile-top-links p-0 text-right"
              onClick={this.drawerToggleClickHandler}
            >
              <label className="more-icons text-center" data-tip="More">
                <ReactTooltip />
                <BsList />
              </label>
            </div>

            {/* <div className="col-lg-1 space-div"></div> */}

            <div className="menu-row-desktop col-lg-8 col-md-8 p-0 pr-3 d-none d-md-block">
              <div className="row justify-content-end">
                <NavLink
                  to="/in"
                  className="links text-center"
                  exact
                  activeClassName="activeLink"
                >
                  <BsHouse size={20} />{" "}
                  <span className="font-normal">Dashboard</span>
                </NavLink>
                &nbsp;&nbsp; <span className="text-grey font-normal">-</span>{" "}
                &nbsp;&nbsp;
                <NavLink
                  to={{ pathname: "/profile" }}
                  className="links text-center"
                  exact
                  activeClassName="activeLink"
                >
                  <BsPerson size={20} />{" "}
                  <span className="font-normal">My Account</span>
                </NavLink>
                &nbsp;&nbsp; <span className="text-grey font-normal">-</span>{" "}
                &nbsp;&nbsp;
                <NavLink
                  to="/feedback"
                  className="links text-center"
                  exact
                  activeClassName="activeLink"
                >
                  <BsPen size={18} />{" "}
                  <span className="font-normal">Feedback</span>
                </NavLink>
                &nbsp;&nbsp; <span className="text-grey font-normal">-</span>{" "}
                &nbsp;&nbsp;
                <NavLink
                  to="#"
                  className="links text-center"
                  exact
                  activeClassName="activeLink"
                  onClick={this.handleLogout}
                >
                  <BiLogOutCircle size={20} />{" "}
                  <span className="font-normal">Log out</span>
                </NavLink>
              </div>
            </div>
            {/* <div className="col-lg-1"></div> */}
          </div>
        </header>
        <div className="spacer" />
      </div>
    );
  }
}

export default withRouter(Header);
